import { render, staticRenderFns } from "./navbarItem.vue?vue&type=template&id=7be6377c&scoped=true"
import script from "./navbarItem.vue?vue&type=script&lang=js"
export * from "./navbarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be6377c",
  null
  
)

export default component.exports